import { getAuth } from "services/identity.service";

const role = getAuth()?.role;
const pagePermissions = {
  "/members": ["super_admin"],
  "/members/action": ["super_admin"],
  // Women's Wear Routes
  "/womens-wear/categories": ["super_admin", "admin"],
  "/womens-wear/categories/action": ["super_admin", "admin"],
  "/womens-wear/categories/[categoryId]/sub-categories": ["super_admin", "admin"],
  "/womens-wear/categories/[categoryId]/sub-categories/action": ["super_admin", "admin"],
  "/womens-wear/banners": ["super_admin", "admin"],
  "/womens-wear/banners/action": ["super_admin", "admin"],
  "/womens-wear/secondary-banners": ["super_admin", "admin"],
  "/womens-wear/secondary-banners/action": ["super_admin", "admin"],
  "/womens-wear/widgets": ["super_admin"],
  "/womens-wear/widgets/action": ["super_admin"],
  "/womens-wear/activities": ["super_admin", "admin"],
  "/womens-wear/activities/action": ["super_admin", "admin"],
  "/womens-wear/secondaryWidgetOne": ["super_admin", "admin"],
  "/womens-wear/secondaryWidgetOne/action": ["super_admin", "admin"],
  "/womens-wear/secondaryWidgetTwo": ["super_admin", "admin"],
  "/womens-wear/secondaryWidgetTwo/action": ["super_admin", "admin"],
  "/womens-wear/deal-widget": ["super_admin", "admin"],
  "/womens-wear/deal-widget/action": ["super_admin", "admin"],
  "/womens-wear/sections": ["super_admin", "admin"],
  "/womens-wear/sections/action": ["super_admin", "admin"],
  "/womens-wear/zenim-wear/hero-video": ["super_admin", "admin"],
  "/womens-wear/zenim-wear/hero-video/action": ["super_admin", "admin"],
  "/womens-wear/zenim-wear/secondary-video": ["super_admin", "admin"],
  "/womens-wear/zenim-wear/secondary-video/action": ["super_admin", "admin"],
  "/womens-wear/zenim-wear/story-grid": ["super_admin", "admin"],
  "/womens-wear/zenim-wear/story-grid/action": ["super_admin", "admin"],
  "/womens-wear/zenim-wear/style-inspiration": ["super_admin", "admin"],
  "/womens-wear/zenim-wear/style-inspiration/action": ["super_admin", "admin"],
  "/womens-wear/blissterry/hero-video": ["super_admin", "admin"],
  "/womens-wear/blissterry/hero-video/action": ["super_admin", "admin"],
  "/womens-wear/blissterry/spotlight": ["super_admin", "admin"],
  "/womens-wear/blissterry/spotlight/action": ["super_admin", "admin"],
  "/womens-wear/blissterry/style-inspiration": ["super_admin", "admin"],
  "/womens-wear/blissterry/style-inspiration/action": ["super_admin", "admin"],
  // Men's Wear Routes
  "/mens-wear/categories": ["super_admin", "admin"],
  "/mens-wear/categories/action": ["super_admin", "admin"],
  "/mens-wear/categories/[categoryId]/sub-categories": ["super_admin", "admin"],
  "/mens-wear/categories/[categoryId]/sub-categories/action": ["super_admin", "admin"],
  "/mens-wear/banners": ["super_admin", "admin"],
  "/mens-wear/banners/action": ["super_admin", "admin"],
  "/mens-wear/secondaryWidgetOne": ["super_admin", "admin"],
  "/mens-wear/secondaryWidgetOne/action": ["super_admin", "admin"],
  "/mens-wear/secondaryWidgetTwo": ["super_admin", "admin"],
  "/mens-wear/secondaryWidgetTwo/action": ["super_admin", "admin"],
  "/mens-wear/secondaryWidgetThree": ["super_admin", "admin"],
  "/mens-wear/secondaryWidgetThree/action": ["super_admin", "admin"],
  "/mens-wear/deal-widget": ["super_admin", "admin"],
  "/mens-wear/deal-widget/action": ["super_admin", "admin"],
  "/mens-wear/use-case-widget": ["super_admin", "admin"],
  "/mens-wear/use-case-widget/action": ["super_admin", "admin"],
  "/mens-wear/sections": ["super_admin", "admin"],
  "/mens-wear/sections/action": ["super_admin", "admin"],
  // Other routes
  "/info-cards": ["super_admin", "admin"],
  "/info-cards/action": ["super_admin", "admin"],
  "/products-info-cards": ["super_admin", "admin"],
  "/products-info-cards/action": ["super_admin", "admin"],
  "/similar-products": ["super_admin", "admin"],
  "/similar-products/action": ["super_admin", "admin"],
  "/cart-similar-product": ["super_admin", "admin"],
  "/cart-similar-product/action": ["super_admin", "admin"],
  "/coupons": ["super_admin", "admin"],
  "/disable-section": ["super_admin", "admin"],
  "/disable-section/action": ["super_admin", "admin"],
  "/marketing-line": ["super_admin", "admin"],
  "/filters": ["super_admin", "admin"],
  "/filters/action": ["super_admin", "admin"],
  "/andriodNotification": ["super_admin", "admin"],
  "/iosNotification": ["super_admin", "admin"],
  "/clear-cache": ["super_admin", "admin"],
  "/global-discount-percentage": ["super_admin", "admin"],
  "/express-delivery-fees": ["super_admin", "admin"],
  "/womens-wear/announcement-bar": ["super_admin", "admin"],
  "/mens-wear/announcement-bar": ["super_admin", "admin"],
  "/mens-wear/mens-header-banner": ["super_admin", "admin"],
  "/mens-wear/mens-header-banner/action": ["super_admin", "admin"],
  "/secondaryWidgetOne": ["super_admin", "admin"],
  "/secondaryWidgetOne/action": ["super_admin", "admin"],
  "/secondaryWidgetTwo": ["super_admin", "admin"],
  "/secondaryWidgetTwo/action": ["super_admin", "admin"],
  "/deal-widget": ["super_admin", "admin"],
  "/deal-widget/action": ["super_admin", "admin"],
  "/sections": ["super_admin", "admin"],
  "/sections/action": ["super_admin", "admin"],
  "/announcement-bar": ["super_admin", "admin"],
  "/show-percentage-off": ["super_admin", "admin"],
  "/pip": ["super_admin", "admin"],
  "/pip/action": ["super_admin", "admin"],
  "/edd-buffer-days": ["super_admin", "admin"],
  "/express-delivery-fees": ["super_admin", "admin"],
  "/express-delivery": ["super_admin", "admin"],
  "/app-version": ["super_admin", "admin"],
  "/gokwik-toggle": ["super_admin", "admin"],
  "/order-success-banner": ["super_admin", "admin"],
  "/show-app-rating": ["super_admin", "admin"],
};

export default function hasPermission(page) {
  if (
    ["/", "/login", "/success", "/terms-pages/privacy", "/_error"].some(
      (url) => url === page
    )
  )
    return true;
  const roles = pagePermissions[page];
  return roles?.some((name) => name === role);
}
